import type { EventDetailNavTab, EventDetailSectionId } from '../types/event-detail'

/** Built-in detail sections, in display order. */
export const EVENT_DETAIL_SECTION_IDS: readonly EventDetailSectionId[] = ['about', 'agenda', 'speakers', 'attendees', 'exhibitors']

export const EVENT_DETAIL_NAV_TABS: readonly EventDetailNavTab[] = [
  { id: 'about', labelKey: 'clientportal.events.detail.nav.about' },
  { id: 'agenda', labelKey: 'clientportal.events.detail.nav.agenda' },
  { id: 'speakers', labelKey: 'clientportal.events.detail.nav.speakers' },
  { id: 'attendees', labelKey: 'clientportal.events.detail.nav.attendees' },
  { id: 'exhibitors', labelKey: 'clientportal.events.detail.nav.exhibitors' },
]

/**
 * The viewer's check-in badge. It sits last in the tab bar but is not a section: picking it opens the badge over the
 * current section, so it is never the active tab.
 */
export const EVENT_DETAIL_BADGE_TAB: EventDetailNavTab = { id: 'badge', labelKey: 'clientportal.events.detail.nav.badge', isAction: true }

/** Collapsed About body height (`12rem` at a 16px root). */
export const EVENT_DETAIL_ABOUT_COLLAPSED_MAX_HEIGHT_PX = 192
